import { render, staticRenderFns } from "./SubmitCandidatesAction.vue?vue&type=template&id=9629700e&scoped=true&"
import script from "./SubmitCandidatesAction.vue?vue&type=script&lang=js&"
export * from "./SubmitCandidatesAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9629700e",
  null
  
)

export default component.exports